import { FC, Fragment, ReactNode } from "react";
import { Link, Popover, PopoverOrigin, Stack, Typography } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import { SvgIconComponent } from "@mui/icons-material";
import { useMenuHook } from "@/utils/hooks/useMenu.hook";

export interface SourceDataChipProps {
  title: string;
  url: string;
  icon: SvgIconComponent;
  openIn: string;
  children?: ReactNode;
}

export const SourceDataChip: FC<SourceDataChipProps> = ({
  url,
  title,
  icon: Icon,
  openIn,
  children,
}) => {
  const { open, openMenu, closeMenu, anchor } = useMenuHook();

  if (!title) {
    return null;
  }

  return (
    <Fragment>
      <Stack
        pl={0.5}
        pr={1}
        py={0.25}
        spacing={0.5}
        direction="row"
        borderRadius={1}
        alignItems="center"
        whiteSpace="nowrap"
        bgcolor={(theme) => theme.palette.primary.light}
      >
        <Stack
          spacing={0.5}
          direction="row"
          sx={{ cursor: "pointer" }}
          alignItems="center"
          onClick={openMenu}
        >
          <Icon sx={{ fontSize: 16 }} color="primary" />

          <Typography
            variant="body2"
            color="primary"
            sx={{ textDecoration: "underline" }}
          >
            {title}
          </Typography>
        </Stack>

        {children}
      </Stack>

      <Popover
        open={open}
        anchorEl={anchor}
        onClose={closeMenu}
        anchorOrigin={anchorOrigin}
        slotProps={slotProps}
      >
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          component={Link}
          href={url}
          target="_blank"
          sx={stackStyles}
        >
          <Typography variant="body2" sx={{ textDecoration: "none" }}>
            Open in {openIn}{" "}
          </Typography>
          <LaunchIcon sx={{ fontSize: 16, ml: 1 }} color="primary" />
        </Stack>
      </Popover>
    </Fragment>
  );
};

const slotProps = {
  paper: { sx: { p: 1 } },
};

const anchorOrigin: PopoverOrigin = {
  vertical: "bottom",
  horizontal: "left",
};

const stackStyles = {
  textDecoration: "none",
  color: "inherit",
  "&:hover": {
    textDecoration: "none",
  },
};
